import EventModel from '../models/event'
import RootController from 'structure-root-controller'

let mixpanel = null
let Mixpanel = null

if(process.env.MIXPANEL_TOKEN) {

  Mixpanel = require('mixpanel')
  mixpanel = Mixpanel.init(process.env.MIXPANEL_TOKEN)

}

/**
 * EventsController Class
 *
 * @public
 * @class EventsController
 */
export default class EventsController extends RootController {

  /**
   * EventsController constructor
   *
   * @public
   * @constructor
   * @param {Object} options - Options
   */
  constructor(options = {}) {
    super(Object.assign({}, {
      name: 'events'
    }, options))
  }

  /**
   * Create new event
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  create(req, res) {

    const event = new EventModel()
    const time = new Date().toISOString()

    let pkg = Object.assign({}, req.body, {
      ip        : req.ip,
      origin    : (req.get('Origin')) ? req.get('Origin').replace(/^https?:\/\//, '') : '',
      referrer  : req.get('Referrer'),
      time,
      useragent : req.get('User-Agent')
    })

    if(mixpanel) {

      let data = req.body.data || null
      let label = Object.assign({}, req.body).label

      if(!data) {
        data = Object.assign({}, req.body)
        delete data.label
      }

      try {
        mixpanel.track(label, data)
      }
      catch(e) {
        console.error(e)
      }

    }

    return event.create(pkg)

  }

  /**
   * Delete an event by id
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  deleteById(req, res) {

    var event = new EventModel()

    return event.deleteById(req.params.id)

  }

  /**
   * Get event by id
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  getById(req, res) {

    const event = new EventModel()

    return event.getById(req.params.id)

  }

  /**
   * Get all events
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  getAll(req, res) {

    const event = new EventModel()

    return event.getAll()

  }

  /**
   * Update a event
   *
   * @public
   * @param {Object} req - Express req
   * @param {Object} res - Express res
   */
  updateById(req, res) {

    const event = new EventModel()

    return event.updateById(req.params.id, req.body)

  }

}
